import type { PlanEvent, Task } from "../../../shared/types";

export function normalizeText(text: string): string {
  return text.toLowerCase().trim();
}

export function matchesQuery(text: string, query: string): boolean {
  return normalizeText(text).includes(normalizeText(query));
}

export function searchTasks(tasks: Task[], query: string): Task[] {
  if (!query) return [];
  return tasks.filter(
    (task) =>
      matchesQuery(task.title, query) ||
      matchesQuery(task.notes, query) ||
      task.tags.some((tag) => matchesQuery(tag, query)),
  );
}

export function searchEvents(events: PlanEvent[], query: string): PlanEvent[] {
  if (!query) return [];
  return events.filter(
    (event) =>
      matchesQuery(event.title, query) ||
      matchesQuery(event.notes, query) ||
      event.tags.some((tag) => matchesQuery(tag, query)),
  );
}
